import Cookies from 'js-cookie'

const SelectedAPStatus = 'status'

export function getSelectedAPStatus() {
  return Cookies.get(SelectedAPStatus)
}

export function setSelectedAPStatus(status) {
  return Cookies.set(SelectedAPStatus, status)
}

